import styled from "styled-components";
import { Accordion } from "components/ui/ChevronAccordion";

export const SectionAccordion = styled(Accordion)`
  border-left: 5px solid var(--${({ color }) => color});
`;
